export default __webpack_public_path__ + "static/kepi-b6bd9c6033bb26758d247b2e1642391e.jpg";